import Vue from 'vue'
export const events = new Vue()


// WEBPACK FOOTER //
// ./src/Plugins/Events.js